'use client'
import { FunctionComponent } from 'react'
import cn from 'classnames'
import { Swiper, SwiperSlide } from 'swiper/react'
import { FreeMode } from 'swiper/modules'
import styles from './Blog.module.scss'
import 'swiper/css'
import 'swiper/css/free-mode'

import { HeaderTag } from '@/components/HeaderTag'
import { Article } from '@/components/Article'
import { ArticleImage } from '@/components/ArticleImage'
import { ButtonLink } from '@/components/ButtonLink'

import moduleStyles from '@/modules/HomePage/HomePage.module.scss'
import { Article as IArticle } from '@/services/Api/generated'

type BlogProps = {
  className?: string
  articles: IArticle[]
}

export const Blog: FunctionComponent<BlogProps> = ({ className, articles }) => {
  return (
    <div className={cn(className, moduleStyles.container)}>
      <HeaderTag
        icon="blog"
        title="Блог Brandside"
        className={moduleStyles.tag}
      />
      <div className={cn(moduleStyles.title, styles.title)}>
        Узнайте больше о регистрации товарного знака
      </div>
      <ButtonLink variant="opacity" className={styles.moreButton} href="/blog">
        Все статьи
      </ButtonLink>
      <Swiper
        className={styles.list}
        spaceBetween={12}
        wrapperClass={styles.swiperWrapper}
        slidesPerView={'auto'}
        modules={[FreeMode]}
        freeMode={true}
        breakpoints={{
          768: {
            enabled: true,
            spaceBetween: 20,
          },
          1024: {
            enabled: false,
            spaceBetween: 0,
          },
        }}
      >
        {articles.slice(0, 3).map((article) => (
          <SwiperSlide key={article.slug} className={styles.item}>
            <Article
              className={styles.article}
              id={article.slug}
              image={
                <ArticleImage
                  image={article.thumbnail?.[0]}
                  sizes="(max-width: 767px) 297px, (min-width: 768px) and (max-width: 1023px) 342px, (min-width: 1024px) and (max-width: 1439px) 260px, (min-width: 1440px) and (max-width: 1919px) 348px, 409px"
                  className={styles.image}
                />
              }
              title={article.title}
              category={article.category}
              publishedAt={article.publishedAt}
              readTime={article.readingTime}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}
